import JSONUtils from '../../lib/JSONUtils';
import safeNotifyPopupOpener from '../../lib/safeNotifyPopupOpener';

/**
 * Reads the provider's response off the OAuth2 callback URL and hands it back to the
 * window that opened the popup.
 *
 * A provider delivers that response in one of two places, and they must be read
 * separately rather than as one blob of text after the first `?` or `#`:
 *
 *   query component  — authorization code flow (RFC 6749 §4.1.2). `code` and `state`
 *                      live here, and §3.1.2 excludes fragments from the redirect URI
 *                      entirely, so anything after `#` is not part of the response.
 *                      Reddit terminates its callback with a bare `#_`, which would
 *                      otherwise ride along inside `code` and be rejected as malformed.
 *
 *   fragment         — implicit and hybrid flows, where the fragment *is* the payload
 *                      (`access_token`, `token_type`, …). Truncating at `#` here would
 *                      hand those providers an empty response.
 *
 * Preferring the query when present is safe because REDIRECT_URI is a bare path with no
 * query string of its own, so a populated `search` can only have come from the provider.
 */
export default function OAuth2Authenticator() {
  const { search, hash } = new URL(window.location.href);
  const responseParams = (search || hash).slice(1);

  if (responseParams) {
    safeNotifyPopupOpener(JSONUtils.queryStringToJSON(responseParams), null);
  } else {
    safeNotifyPopupOpener(null, {
      code: 'Authentication error',
      description: 'Authentication error',
    });
  }

  // Unconditional, as before: the popup closes even with no opener to report to.
  window.location.replace('about:blank');
  window.close();
  return null;
}
